const projectsData = 
[
  {
    "id": 1,
    "title": "CURIFY",
    "main_image": require("../assets/projects/p1/landing.png"),
    "images": [require("../assets/projects/p1/moodpick.png"), require("../assets/projects/p1/playlistpick.png"), require("../assets/projects/p1/loading.png"), require("../assets/projects/p1/results.png")],
    "description": "Curify generates a list of curated Netflix shows and movies based on users’ own selected Spotify playlist.",
    "stack": "ReactJS / Spotify API / Railway / Figma",
    "link": "https://github.com/Apple-Piethon/curify",
    "link_desc": "ONGOING PROJECT",
    "app_type": "web",
  },
  {
    "id": 2,
    "title": "MICHAEL SCOTT GPT-3",
    "main_image": require("../assets/projects/p2/landing.png"),
    "images": [],
    "description": "A chat bot of Michael Scott from the mockumentary series, The Office. Accessible via web app and chrome extension.",
    "stack": "ReactJS / GPT-3",
    "link": "https://github.com/britneywwc/gpt3-writer-starter",
    "link_desc": "GITHUB",
    "app_type": "web",
  },
  {
    "id": 3,
    "title": "INTREPIDUS",
    "main_image": require("../assets/projects/p3/landing.png"),
    "images": [require("../assets/projects/p3/1.png"), require("../assets/projects/p3/2.png"), require("../assets/projects/p3/3.png"), require("../assets/projects/p3/4.png"), require("../assets/projects/p3/5.png"), require("../assets/projects/p3/6.png"), require("../assets/projects/p3/7.png"), require("../assets/projects/p3/8.png")],
    "description": "Intrepidus is a mobile application that helps astronauts shift their sleep according to their circadian rhythm, also included suggested meal and exercise times. Submission for NASA Space Apps Challenge 2020.",
    "stack": "Flutter / Dart / Firebase",
    "link": "https://github.com/daniaismadi/intrepidus",
    "link_desc": "GITHUB",
    "app_type": "mobile",
  },
]

export default projectsData;